import React, { useContext } from 'react';
import classnames from 'classnames';
import { FocusBaseContext, MarkupContext } from '../../contexts';

const SummaryViews = () => {
  const { currentSummary, heatmap, currentKinds, findMarkupType } = useContext(FocusBaseContext);
  const { allowedReactions } = useContext(MarkupContext);
  const colors = currentSummary.colors;

  const totals = (
    heatmap.totals ? heatmap.totals[findMarkupType()] : {}
  );

  return (
    <div className="summary-markup_views">
      <table>
        <thead>
          <tr>
            <th />
            <th style={ { color: currentKinds.positive ? colors.positive : null } }>Positive</th>
            <th style={ { color: currentKinds.negative ? colors.negative : null } }>Negative</th>
            {
              allowedReactions.confusing &&
              <th style={ { color: currentKinds.confusing ? colors.confusing : null } }>
                Confusing
              </th>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total views</td>
            <td className={ classnames({ 'gray': !currentKinds.positive }) }>
              { totals.positive.all }
            </td>
            <td className={ classnames({ 'gray': !currentKinds.negative }) }>
              { totals.negative.all }
            </td>
            {
              allowedReactions.confusing &&
              <td className={ classnames({ 'gray': !currentKinds.confusing }) }>
                { totals.confusing.all }
              </td>
            }
          </tr>
          <tr>
            <td>Marked up</td>
            <td className={ classnames({ 'gray': !currentKinds.positive }) }>
              { totals.positive.marked } or { totals.positive_percent.marked }%
            </td>
            <td className={ classnames({ 'gray': !currentKinds.negative }) }>
              { totals.negative.marked } or { totals.negative_percent.marked }%
            </td>
            {
              allowedReactions.confusing &&
              <td className={ classnames({ 'gray': !currentKinds.confusing }) }>
                { totals.confusing.marked } or { totals.confusing_percent.marked }%
              </td>
            }
          </tr>
          <tr>
            <td>Commented</td>
            <td className={ classnames({ 'gray': !currentKinds.positive }) }>
              { totals.positive.commented } or { totals.positive_percent.commented }%
            </td>
            <td className={ classnames({ 'gray': !currentKinds.negative }) }>
              { totals.negative.commented } or { totals.negative_percent.commented }%
            </td>
            {
              allowedReactions.confusing &&
              <td className={ classnames({ 'gray': !currentKinds.confusing }) }>
                { totals.confusing.commented } or { totals.confusing_percent.commented }%
              </td>
            }
          </tr>
        </tbody>

      </table>
    </div>
  );
};

export default SummaryViews;
